(() => {
  if (window.bbbNavigationLoaded) return;
  window.bbbNavigationLoaded = true;
  let opener = null;
  let lastBranch = null;
  const dialog = () => document.getElementById('BbbNavDialog');
  function showHome(restore = false) {
    const root = dialog();
    if (!root) return;
    root.classList.remove('has-panel');
    root.querySelectorAll('[data-bbb-panel]').forEach(panel => panel.hidden = true);
    root.querySelectorAll('[data-bbb-home]').forEach(panel => panel.hidden = false);
    root.querySelectorAll('[data-bbb-next]').forEach(button => button.setAttribute('aria-expanded', 'false'));
    if (restore && lastBranch) lastBranch.focus();
  }
  function closed() {
    document.documentElement.classList.remove('bbb-menu-lock');
    document.querySelectorAll('[data-bbb-open]').forEach(button => button.setAttribute('aria-expanded', 'false'));
    if (opener?.isConnected) opener.focus();
  }
  function closeDesktop(except) {
    document.querySelectorAll('[data-bbb-disclosure][open]').forEach(el => { if (el !== except) el.open = false; });
  }
  document.addEventListener('click', event => {
    const close = event.target.closest('[data-bbb-close-desktop]');
    if (close) { const details = close.closest('details'); details.open = false; details.querySelector('summary').focus(); return; }
    const open = event.target.closest('[data-bbb-open]');
    if (open) {
      const root = dialog();
      if (!root) return;
      opener = open;
      closeDesktop();
      showHome();
      if (!root.open) root.showModal();
      root.querySelector('.bbb-mobile__scroll').scrollTop = 0;
      document.documentElement.classList.add('bbb-menu-lock');
      open.setAttribute('aria-expanded', 'true');
      root.querySelector('[data-bbb-close]').focus();
      return;
    }
    if (event.target.closest('[data-bbb-close]')) { dialog()?.close(); closed(); return; }
    if (event.target.closest('[data-bbb-back]')) { showHome(true); return; }
    const next = event.target.closest('[data-bbb-next]');
    if (next) {
      const root = dialog();
      const panel = document.getElementById(next.dataset.bbbNext);
      if (!panel || !root) return;
      lastBranch = next;
      showHome();
      root.classList.add('has-panel');
      root.querySelectorAll('[data-bbb-home]').forEach(el => el.hidden = true);
      panel.hidden = false;
      next.setAttribute('aria-expanded', 'true');
      root.querySelector('.bbb-mobile__scroll').scrollTop = 0;
      panel.querySelector('h2').focus();
      return;
    }
    if (!event.target.closest('.bbb-desktop')) closeDesktop();
    if (event.target === dialog()) {
      const rect = dialog().getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) { dialog().close(); closed(); }
    }
  });
  document.addEventListener('toggle', event => {
    if (event.target.matches?.('[data-bbb-disclosure]') && event.target.open) closeDesktop(event.target);
  }, true);
  document.addEventListener('close', event => { if (event.target.id === 'BbbNavDialog') closed(); }, true);
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    if (dialog()?.open) {
      if (dialog().classList.contains('has-panel')) { event.preventDefault(); event.stopPropagation(); showHome(true); }
      return;
    }
    const open = document.querySelector('[data-bbb-disclosure][open]');
    if (open) { open.open = false; open.querySelector('summary').focus(); }
  });
  const desktop = matchMedia('(min-width:990px)');
  let headerFrame = 0;
  const searchPlaceholders = new WeakMap();
  function syncMobileHeaderHeight() {
    const header = document.querySelector('.bbb-header');
    if (!header) return;
    const compact = !desktop.matches && header.classList.contains('site-header--stuck');
    header.querySelectorAll('.rps-csb-input').forEach(input => {
      if (!searchPlaceholders.has(input)) searchPlaceholders.set(input, input.placeholder);
      const placeholder = desktop.matches ? searchPlaceholders.get(input) : compact ? header.dataset.bbbSearchShort : header.dataset.bbbSearchFull;
      if (placeholder && input.placeholder !== placeholder) input.placeholder = placeholder;
    });
    if (desktop.matches) return;
    const wrap = document.getElementById('StickyHeaderWrap');
    if (!wrap) return;
    const height = header.getBoundingClientRect().height;
    const logo = header.querySelector('.header-item--logo');
    const expandedHeight = compact
      ? Math.max(44, logo?.getBoundingClientRect().height || 0) + 44 + 4 + 16 + parseFloat(getComputedStyle(header).borderBottomWidth || 0)
      : height;
    const reserved = expandedHeight + 'px';
    if (wrap.style.height !== reserved) wrap.style.height = reserved;
    for (const property of ['--header-height', '--bbb-header-height']) {
      if (document.documentElement.style.getPropertyValue(property) !== height + 'px') {
        document.documentElement.style.setProperty(property, height + 'px');
      }
    }
  }
  function scheduleHeaderSync() {
    if (headerFrame) return;
    headerFrame = requestAnimationFrame(() => {
      headerFrame = 0;
      syncMobileHeaderHeight();
    });
  }
  const headerObserver = new ResizeObserver(scheduleHeaderSync);
  const headerMutationObserver = new MutationObserver(scheduleHeaderSync);
  function observeHeader() {
    headerObserver.disconnect();
    headerMutationObserver.disconnect();
    const header = document.querySelector('.bbb-header');
    const wrapper = document.getElementById('HeaderWrapper');
    if (header) {
      headerObserver.observe(header);
      const logo = header.querySelector('.header-item--logo');
      if (logo) headerObserver.observe(logo);
    }
    if (wrapper) headerMutationObserver.observe(wrapper, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
    scheduleHeaderSync();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observeHeader, { once: true });
  else observeHeader();
  document.addEventListener('shopify:section:load', observeHeader);
  window.addEventListener('resize', scheduleHeaderSync, { passive: true });
  desktop.addEventListener('change', scheduleHeaderSync);
  desktop.addEventListener('change', event => { if (event.matches && dialog()?.open) { dialog().close(); closed(); } else closeDesktop(); });
  document.addEventListener('shopify:section:unload', event => {
    if (event.target.querySelector('#BbbNavDialog')) document.documentElement.classList.remove('bbb-menu-lock');
  });
})();


